<template>
  <div
    class="card-content_wrapper"
    :class="{ blur: !loaded }"
    v-if="optional($auth.user(), 'org_role.role_id') == 1"
  >
    <delete-modal
      @trigger="setDeleteState"
      @cancel="cancelDelete"
      @deleteAction="deletePaymentMethod"
      :showDelete="showDelete"
      :name="showDeleteName"
      ref="delete"
    ></delete-modal>
    <div class="card-caption d-flex justify-content-between pt-3 pb-2 pl-4">
      <div>
        <h6 class="text-bold text-opacity-pale">Organization Information</h6>
      </div>
      <div class="mr-3">
        <router-link :to="{ name: 'organization-edit' }">
          <button class="card-btn">Edit Organization</button>
        </router-link>
      </div>
    </div>
    <div
      class="card-description"
      v-if="user.organization && user.organization.id"
    >
      <div class="row pl-4 pt-3 pr-4">
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Name</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            {{ user.organization.name }}
          </h6>
        </div>
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Business Email</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            {{ user.organization.business_email }}
          </h6>
        </div>
      </div>
      <div class="row pl-4 pt-3 pr-4">
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Website</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            <a :href="user.organization.website || '#'">{{
              user.organization.website
            }}</a>
          </h6>
        </div>
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Industry</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            {{ user.industry ? user.industry.name : "N/A" }}
          </h6>
        </div>
      </div>
      <div class="row pl-4 pt-3 pr-4">
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Joined</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            {{ toLocal(user.organization.created_at).format("MM/DD/YYYY") }}
          </h6>
        </div>
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Default Currency</small>
          <h6 class="h7 pt-1 text-opacity-pale">
            {{
              user.default_currency && user.default_currency.name
                ? user.default_currency.name
                : "N/A"
            }}
          </h6>
        </div>
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Address</small>
          <h6 class="h7 pt-1 text-opacity-pale" v-if="user.address">
            {{
              `${user.address.address} ${
                user.address.city && user.address.city.name
                  ? user.address.city.name
                  : ""
              } ${user.address.region ? user.address.region.name : ""} ${
                user.address.country ? user.address.country.name : ""
              } ${user.address.post_code}`
            }}
          </h6>
        </div>
        <div class="col-sm-12 col-lg-6">
          <small class="text-opacity">Pay Period</small>
          <h6
            class="h7 pt-1 text-opacity-pale"
            v-if="user.organization.pay_period_id"
          >
            {{ user.pay_period | optional("name", "N/A") }}
          </h6>
        </div>
      </div>
    </div>
    <div
      class="card-caption d-flex justify-content-between pt-3 pb-2 pl-4 mt-4"
    >
      <div>
        <h6 class="text-bold text-opacity-pale">Payment Methods</h6>
      </div>
      <div class="mr-3">
        <router-link :to="{ name: 'settings-payment' }">
          <button class="card-btn">+ Add New Payment Method</button>
        </router-link>
      </div>
    </div>
    <div
      class="card-description"
      v-if="user.organization && user.organization.id"
    >
      <div
        class="row api-keys pl-4 pr-4 pt-4"
        v-if="payment_methods && payment_methods.length > 0"
      >
        <div
          class="col-sm-12 col-lg-6 p-4"
          v-for="(p, index) in payment_methods"
          :key="index"
        >
          <span>
            <span v-html="p.logo"></span>
            <sup
              class="ml-3"
              v-b-tooltip.hover
              :title="'Edit' + ' ' + p.name + ' ' + 'Credentials'"
            >
              <router-link
                :to="{ name: 'settings-payment', query: { id: p.id } }"
              >
                <button
                  style="
                    height: 25px;
                    width: 25px;
                    border-radius: 25px;
                    font-size: 15px;
                    border: 1px solid #e4e4e4;
                    background: #f5f5f5;
                  "
                >
                  <i class="zmdi zmdi-edit"></i>
                </button>
              </router-link>
            </sup>
            <span @click="setDeleteState('payment method', p.id)" class="badge badge-danger float-right">Delete</span>
          </span>
          <div class="pt-3 d-flex justify-content-between">
            <div class>
              <small class="text-opacity">Public Key</small>
              <h6 class="h7 pt-2 text-bolder text-opacity-pale">
                {{ "*********" }}
              </h6>
            </div>
            <div class>
              <small class="text-opacity">Private Key</small>
              <h6 class="h7 text-bolder pt-2 text-opacity-pale">
                {{ "*********" }}
              </h6>
            </div>
          </div>
        </div>
      </div>
      <div class="pl-4 pr-4 pt-5 text-center" v-else>
        <h6 class="h7 text-opacity-pale">
          No Payment Method has been added yet.
        </h6>
        <h6 class="h7 text-bold pt-3">
          <router-link
            :to="{ name: 'settings-payment' }"
            style="
              color: rgb(63, 146, 204) !important;
              text-decoration: none !important;
            "
          >
            <span class="pl-2 pr-1">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
              >
                <path
                  fill="#3f92cc"
                  d="M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zm0 4c-.552 0-1 .448-1 1v2H5c-.552 0-1 .448-1 1s.448 1 1 1h2v2c0 .552.448 1 1 1s1-.448 1-1V9h2c.552 0 1-.448 1-1s-.448-1-1-1H9V5c0-.552-.448-1-1-1z"
                ></path>
              </svg>
            </span>
            Add Payment Method
          </router-link>
        </h6>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<style lang="scss" scoped>
.badge {
  &.badge-danger {
    background: #e4e4e4 !important;
    color: red;
    opacity: 0.7;

    &:hover {
      background: red !important;
      color: white;
    }
  }
}
.api-keys {
  .logo {
    width: 15%;
  }
  .col-lg-6 {
    &:nth-child(2n + 2) {
      // display:
      border-left: 1px dashed #e4e4e4;
      border-bottom: 1px dashed #e4e4e4;
    }
    // &:nth-child(4) {
    //   border-left: 1px dashed #e4e4e4;
    //   border-top: 1px dashed #e4e4e4;
    //   //   margin-top: 1px;
    // }
    &:nth-child(2n + 3) {
      border-top: 1px dashed #e4e4e4;
      border-right: 1px dashed #e4e4e4;
    }
  }
}
</style>

<script>
import { toLocal } from "@/helpers/date";
import getOrganization from "@/helpers/getOrganization";
import DeleteModal from "@/components/Modals/Delete";
import {optional} from "@/helpers/random";

export default {
  data() {
    return {
      showDelete: false,
      showDeleteName: "",
      selectedDeleteId: 0,
      user: {
        organization: {},
      },
      payment_processors: [
        {
          id: 1,
          name: "Stripe",
          link: "stripe-credentials",
          icon: `<svg
                width="55px"
                height="30px"
                viewBox="0 0 512 214"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                preserveAspectRatio="xMidYMid"
              >
                <g>
                  <path
                    d="M35.9822222,83.4844444 C35.9822222,77.9377778 40.5333333,75.8044444 48.0711111,75.8044444 C58.88,75.8044444 72.5333333,79.0755556 83.3422222,84.9066667 L83.3422222,51.4844444 C71.5377778,46.7911111 59.8755556,44.9422222 48.0711111,44.9422222 C19.2,44.9422222 0,60.0177778 0,85.1911111 C0,124.444444 54.0444444,118.186667 54.0444444,135.111111 C54.0444444,141.653333 48.3555556,143.786667 40.3911111,143.786667 C28.5866667,143.786667 13.5111111,138.951111 1.56444444,132.408889 L1.56444444,166.257778 C14.7911111,171.946667 28.16,174.364444 40.3911111,174.364444 C69.9733333,174.364444 90.3111111,159.715556 90.3111111,134.257778 C90.1688889,91.8755556 35.9822222,99.4133333 35.9822222,83.4844444 Z M132.124444,16.4977778 L97.4222222,23.8933333 L97.28,137.813333 C97.28,158.862222 113.066667,174.364444 134.115556,174.364444 C145.777778,174.364444 154.311111,172.231111 159.004444,169.671111 L159.004444,140.8 C154.453333,142.648889 131.982222,149.191111 131.982222,128.142222 L131.982222,77.6533333 L159.004444,77.6533333 L159.004444,47.36 L131.982222,47.36 L132.124444,16.4977778 Z M203.235556,57.8844444 L200.96,47.36 L170.24,47.36 L170.24,171.804444 L205.795556,171.804444 L205.795556,87.4666667 C214.186667,76.5155556 228.408889,78.5066667 232.817778,80.0711111 L232.817778,47.36 C228.266667,45.6533333 211.626667,42.5244444 203.235556,57.8844444 Z M241.493333,47.36 L277.191111,47.36 L277.191111,171.804444 L241.493333,171.804444 L241.493333,47.36 Z M241.493333,36.5511111 L277.191111,28.8711111 L277.191111,0 L241.493333,7.53777778 L241.493333,36.5511111 Z M351.431111,44.9422222 C337.493333,44.9422222 328.533333,51.4844444 323.555556,56.0355556 L321.706667,47.2177778 L290.417778,47.2177778 L290.417778,213.048889 L325.973333,205.511111 L326.115556,165.262222 C331.235556,168.96 338.773333,174.222222 351.288889,174.222222 C376.746667,174.222222 399.928889,153.742222 399.928889,108.657778 C399.786667,67.4133333 376.32,44.9422222 351.431111,44.9422222 Z M342.897778,142.933333 C334.506667,142.933333 329.528889,139.946667 326.115556,136.248889 L325.973333,83.4844444 C329.671111,79.36 334.791111,76.5155556 342.897778,76.5155556 C355.84,76.5155556 364.8,91.0222222 364.8,109.653333 C364.8,128.711111 355.982222,142.933333 342.897778,142.933333 Z M512,110.08 C512,73.6711111 494.364444,44.9422222 460.657778,44.9422222 C426.808889,44.9422222 406.328889,73.6711111 406.328889,109.795556 C406.328889,152.604444 430.506667,174.222222 465.208889,174.222222 C482.133333,174.222222 494.933333,170.382222 504.604444,164.977778 L504.604444,136.533333 C494.933333,141.368889 483.84,144.355556 469.76,144.355556 C455.964444,144.355556 443.733333,139.52 442.168889,122.737778 L511.715556,122.737778 C511.715556,120.888889 512,113.493333 512,110.08 Z M441.742222,96.5688889 C441.742222,80.4977778 451.555556,73.8133333 460.515556,73.8133333 C469.191111,73.8133333 478.435556,80.4977778 478.435556,96.5688889 L441.742222,96.5688889 L441.742222,96.5688889 Z"
                    fill="#6772E5"
                  ></path>
                </g>
              </svg>`,
        },
        {
          id: 2,
          name: "Authorize.net",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" width="120px" height="30px" viewBox="0 0 455.201 59.298">
  <g id="Group_1" data-name="Group 1" transform="translate(-69.649 -290.548)">
    <path id="Path_1" data-name="Path 1" d="M93.531,309.925h.234L99.7,326.851H87.659l5.872-16.926m7.217,38.871h22.484v-2.561c-4.348-.545-5.675-.878-8.515-8.635-3.116-8.306-6.741-18.112-10.183-27.8l-5.41-15.266-4.033,1.111L78.5,337.858c-2.867,7.395-3.939,7.784-8.852,8.377V348.8H88.156v-2.561L86.125,346c-3.8-.425-3.944-1.3-2.74-5.434,1.069-3.559,2.141-7.162,3.15-9.557h14.549c1.24,3.01,2.8,7.309,3.868,10.033,1.39,3.534.966,4.437-2.055,4.882l-2.149.307Z" fill="#004b63"/>
    <path id="Path_2" data-name="Path 2" d="M146.751,320.247c0-3-.4-3.529-2.527-3.887l-2.549-.4v-2.384c4.115-.208,11.256-1.008,15.118-1.532v27.9c0,3.4.33,4.32,2.945,4.32h2.553V346.8a146.736,146.736,0,0,0-14.888,3.049l-.652-.564v-5.259c-1.55,1.146-2.932,2.191-4.745,3.3-2.54,1.547-4.608,2.4-7.193,2.4-6.855,0-10.635-4.556-10.635-10.862V320.247c0-3-.4-3.529-2.52-3.887l-2.228-.4v-2.384c3.778-.208,10.512-1.008,14.8-1.532v24.779c0,4.827,2.457,6.722,5.543,6.722,2.307,0,4.6-1.079,6.981-3.146V320.247" fill="#004b63"/>
    <path id="Path_3" data-name="Path 3" d="M177.04,336.692c0,6.3,3.111,7.478,4.6,7.478a8.712,8.712,0,0,0,4.276-1.323l1.13,2.458-7.062,3.562a8.3,8.3,0,0,1-3.1.858c-6.342,0-9.873-2.755-9.873-10.055V316.862h-5.26l-.578-1.047,2.635-3.146h3.2v-5.012l8.612-6.483,1.423.693v10.8h8.124c1.062.9.912,3.523-.567,4.193H177.04v19.83" fill="#004b63"/>
    <path id="Path_4" data-name="Path 4" d="M203.61,316.963c2.775-2.74,6.923-5.254,11.216-5.254,7.466,0,11.591,4.678,11.591,12.418v16.644c0,4.6.41,4.919,4.953,5.464V348.8H212.081v-2.561c3.972-.545,4.292-.862,4.292-5.464V325.027c0-5.076-2.842-7.232-6.263-7.232a9.1,9.1,0,0,0-6.5,2.7v20.278c0,4.6.394,4.919,3.818,5.464V348.8H187.655v-2.561c5.488-.545,5.9-.862,5.9-5.464V301.1c0-4.859-.156-4.974-5.357-5.29v-2.367c3.641-.563,9.965-1.741,15.408-2.893v26.415" fill="#004b63"/>
    <path id="Path_5" data-name="Path 5" d="M244.054,328.343c0-8.892,3.482-13.246,6.837-13.246,5.251,0,8.4,6.332,8.4,17.3,0,11.882-3.686,13.921-6.663,13.921-5.277,0-8.575-7.653-8.575-17.973m8.079-16.634c-9.227,0-19.413,6.914-19.413,19.932,0,8.783,6.332,18.084,18.985,18.084,9.461,0,18.921-6.425,18.921-19.821C270.626,320.352,263.556,311.709,252.133,311.709Z" fill="#004b63"/>
    <path id="Path_6" data-name="Path 6" d="M288.207,340.771c0,4.586.4,4.919,6.721,5.464V348.8H272.571v-2.561c5.159-.545,5.582-.878,5.582-5.464V322.556c0-5.012-.155-5.073-5.435-5.673v-2.214c4.8-.68,10.057-1.772,15.489-2.96v8.161h.164a33.213,33.213,0,0,1,3.838-5.255c1.566-1.665,3.376-2.906,5.431-2.906a5.253,5.253,0,0,1,5.511,5.017,6.293,6.293,0,0,1-3.888,5.83,2.41,2.41,0,0,1-2.535-.334,6.806,6.806,0,0,0-4.1-1.729c-1.387,0-3.038.623-4.42,4.046v16.232" fill="#004b63"/>
    <path id="Path_7" data-name="Path 7" d="M309.625,322.556c0-5.012-.158-5.073-5.415-5.673v-2.214c4.829-.68,10.275-1.772,15.467-2.96v28.958c0,4.69.408,5.023,5.633,5.568V348.8H303.969v-2.561c5.258-.545,5.656-.878,5.656-5.568V322.556m10.3-23.81a5.886,5.886,0,0,1-5.962,5.932,5.953,5.953,0,1,1,0-11.906A5.914,5.914,0,0,1,319.922,298.746Z" fill="#004b63"/>
    <path id="Path_8" data-name="Path 8" d="M357.98,312.654l.725,1.181-18.89,31.47h6.5c5.652,0,7.851-1.028,10.607-5.7l1.208-2.039,2.956,1.094c-1.471,4.082-2.533,7.125-3.781,10.133H327.661l-.819-1.2,19.475-31.459h-5.772c-5.43,0-6.888,1.246-8.77,5.295l-1.169,2.516-2.945-1.1c.967-3.108,2.268-8.312,3.029-11.906h1.819c.415,1.206,1.3,1.718,4.428,1.718H357.98" fill="#004b63"/>
    <path id="Path_9" data-name="Path 9" d="M370.58,325.312c.486-5.578,3.531-9.836,6.561-9.836,3.126,0,5.743,4.309,5.743,7.639,0,1.6-.316,1.942-1.537,1.942l-10.767.255m20.379,13.971c-3.305,2.22-5.854,3.179-8.885,3.179-6.261,0-11.853-4.245-11.853-13.451,8.162-.321,19.1-1.082,20.24-1.32,1.637-.315,1.878-.5,1.878-3.578,0-6.349-5.678-12.376-12.806-12.376-10.012,0-18.871,8.817-18.871,20.658,0,9.206,6.379,17.33,17.467,17.33,2.865,0,9.289-1.657,13.969-8.807Z" fill="#004b63"/>
    <path id="Path_10" data-name="Path 10" d="M394.987,343.3a6.262,6.262,0,1,1,6.216,6.43,6.1,6.1,0,0,1-6.216-6.43" fill="#004b63"/>
    <path id="Path_11" data-name="Path 11" d="M460.509,349.388h-5L422.873,309.32h-.181v17.011a120.859,120.859,0,0,0,.814,15.748c.431,2.847,2.482,3.925,7.934,4.156V348.8H411.05v-2.561c4.117-.158,6.082-1.309,6.467-4.156a108.9,108.9,0,0,0,.855-15.748v-16.3c0-5.226,0-7.256-1.492-9.2-1.564-2-3.622-2.516-6.978-2.79v-2.581h14.287l31.8,36.982h.17v-14.5a115.9,115.9,0,0,0-.816-15.728c-.41-2.894-2.478-3.9-7.919-4.176v-2.581h20.389v2.581c-4.128.158-6.073,1.282-6.488,4.176a118.019,118.019,0,0,0-.811,15.728v31.448" fill="#004b63"/>
    <path id="Path_12" data-name="Path 12" d="M473.2,325.312c.473-5.578,3.522-9.836,6.548-9.836,3.115,0,5.737,4.309,5.737,7.639,0,1.6-.294,1.942-1.557,1.942l-10.728.255m20.38,13.971c-3.316,2.22-5.85,3.179-8.913,3.179-6.227,0-11.8-4.245-11.8-13.451,8.126-.321,19.059-1.082,20.208-1.32,1.64-.315,1.877-.5,1.877-3.578,0-6.349-5.654-12.376-12.8-12.376-10.022,0-18.9,8.817-18.9,20.658,0,9.206,6.414,17.33,17.478,17.33,2.891,0,9.308-1.657,13.985-8.807Z" fill="#004b63"/>
    <path id="Path_13" data-name="Path 13" d="M510.949,336.692c0,6.3,3.1,7.478,4.606,7.478a8.625,8.625,0,0,0,4.247-1.323l1.154,2.458-7.067,3.562a8.186,8.186,0,0,1-3.12.858c-6.306,0-9.9-2.755-9.9-10.055V316.862h-5.218l-.575-1.047,2.641-3.146h3.152v-5.012l8.662-6.483,1.414.693v10.8h8.121c1.074.9.882,3.523-.576,4.193h-7.545v19.83" fill="#004b63"/>
    <path id="Path_14" data-name="Path 14" d="M520.715,309.671a4.119,4.119,0,0,1-4.122-4.124,4.135,4.135,0,0,1,.552-2.07,3.92,3.92,0,0,1,1.523-1.51,4.094,4.094,0,0,1,4.106,0,3.933,3.933,0,0,1,1.515,1.51,4.122,4.122,0,0,1-3.574,6.194m0-.627a3.4,3.4,0,0,0,1.725-.453,3.328,3.328,0,0,0,1.3-1.268,3.381,3.381,0,0,0,.479-1.774,3.624,3.624,0,0,0-.457-1.756,3.462,3.462,0,0,0-1.29-1.281,3.516,3.516,0,0,0-1.757-.466,3.371,3.371,0,0,0-1.73.466,3.282,3.282,0,0,0-1.3,1.281,3.554,3.554,0,0,0-.463,1.756A3.428,3.428,0,0,0,519,308.591,3.385,3.385,0,0,0,520.715,309.044Zm-.773-1.039h-.806v-4.993h1.607a1.835,1.835,0,0,1,.891.171,1.251,1.251,0,0,1,.472.492,1.552,1.552,0,0,1,.169.7,1.691,1.691,0,0,1-.231.836,1.6,1.6,0,0,1-.734.611,2.12,2.12,0,0,1,.561.722l.779,1.464h-.9l-.648-1.226-.159-.316c-.19-.333-.322-.5-.411-.5h-.586Zm0-2.653h.541a.873.873,0,0,0,.754-.291,1.093,1.093,0,0,0,.21-.646.876.876,0,0,0-.081-.391.85.85,0,0,0-.252-.286,1.077,1.077,0,0,0-.586-.117h-.586Z" fill="#004b63"/>
  </g>
</svg>
`,
        },
        {
          id: 3,
          name: "OFX",
          icon: `<svg xmlns="http://www.w3.org/2000/svg" style="transform:translateX(-50px)" xmlns:xlink="http://www.w3.org/1999/xlink" width="150px" height="20px" viewBox="0 0 959.16 349.5" version="1.1"> <g id="surface1"> <path style=" stroke:none;fill-rule:nonzero;fill:rgb(97.599792%,61.599731%,26.298523%);fill-opacity:1;" d="M 289.242188 174.75 C 289.242188 188.824219 277.925781 200.144531 263.847656 200.144531 L 244.550781 200.144531 C 210.449219 200.144531 178.960938 218.285156 161.980469 247.742188 L 152.402344 264.429688 C 145.4375 276.617188 129.765625 280.683594 117.722656 273.714844 C 105.535156 266.75 101.46875 251.222656 108.4375 239.035156 L 118.011719 222.347656 C 134.992188 192.890625 134.992188 156.464844 118.011719 127.007813 L 108.871094 111.046875 C 101.90625 98.855469 105.386719 83.039063 117.289063 75.785156 C 129.476563 68.382813 145.292969 72.589844 152.402344 84.78125 L 161.980469 101.46875 C 178.960938 130.925781 210.449219 149.066406 244.550781 149.066406 L 263.851563 149.066406 C 277.78125 149.355469 289.242188 160.675781 289.242188 174.75 M 87.394531 23.398438 C 3.808594 71.71875 -24.777344 178.523438 23.398438 262.105469 C 71.71875 345.691406 178.523438 374.277344 262.105469 326.101563 C 345.691406 277.777344 374.277344 170.976563 326.101563 87.394531 C 277.925781 3.808594 170.976563 -24.777344 87.394531 23.398438 M 954.4375 101.324219 C 961.691406 91.019531 959.949219 76.511719 949.9375 68.964844 C 939.488281 61.128906 924.6875 63.59375 917.285156 74.1875 L 882.460938 123.960938 C 878.832031 129.1875 870.996094 129.1875 867.367188 123.960938 L 832.542969 74.1875 C 828.335938 68.238281 821.515625 64.320313 813.675781 64.320313 L 675.675781 64.320313 C 662.90625 64.320313 652.601563 74.621094 652.601563 87.394531 L 652.601563 132.378906 C 652.601563 145.003906 662.328125 156.03125 674.949219 156.320313 C 688.011719 156.757813 698.601563 146.308594 698.601563 133.394531 L 698.601563 119.605469 C 698.601563 114.53125 702.667969 110.464844 707.746094 110.464844 L 796.84375 110.464844 C 799.890625 110.464844 802.648438 111.917969 804.390625 114.382813 L 835.734375 159.078125 C 842.40625 168.65625 842.40625 181.28125 835.734375 190.714844 L 795.390625 248.320313 C 788.136719 258.625 789.878906 273.136719 799.890625 280.683594 C 810.339844 288.519531 825.140625 286.050781 832.539063 275.460938 L 867.367188 225.683594 C 870.996094 220.460938 878.832031 220.460938 882.460938 225.683594 L 916.707031 274.585938 C 923.960938 284.890625 938.183594 288.375 948.773438 281.40625 C 959.660156 274.296875 962.414063 259.496094 955.015625 248.902344 L 914.09375 190.566406 C 907.417969 180.992188 907.417969 168.367188 914.09375 158.933594 Z M 633.882813 174.75 C 633.882813 113.804688 584.402344 64.320313 523.453125 64.320313 C 462.507813 64.320313 413.023438 113.804688 413.023438 174.75 C 413.023438 235.695313 462.507813 285.179688 523.453125 285.179688 C 584.402344 285.179688 633.882813 235.695313 633.882813 174.75 M 587.882813 174.75 C 587.882813 210.300781 559.007813 239.179688 523.453125 239.179688 C 487.902344 239.179688 459.023438 210.300781 459.023438 174.75 C 459.023438 139.195313 487.898438 110.320313 523.453125 110.320313 C 559.007813 110.320313 587.882813 139.195313 587.882813 174.75 M 652.75 262.105469 C 652.75 274.878906 663.050781 285.179688 675.820313 285.179688 C 688.589844 285.179688 698.75 274.878906 698.75 262.105469 C 698.75 226.554688 727.625 197.679688 763.179688 197.679688 C 775.949219 197.679688 786.25 187.375 786.25 174.605469 C 786.25 161.835938 775.949219 151.53125 763.179688 151.53125 C 702.230469 151.679688 652.75 201.160156 652.75 262.105469 "/> </g> </svg>`,
        },
      ],
      loaded: false,
      getOrganization,
    };
  },
  components: {
    DeleteModal
  },
  methods: {
    toLocal,
    optional,
    getPaymentKeys() {
      //todo: refactor once the api to get all registered keys is available
    },
    formatData() {
      this.user = JSON.parse(JSON.stringify(this.$auth.user()));
      this.user.organization =this.$store.getters['global/selected_org']

      this.user.country =
        this.$store.getters["global/countries"].find(
          (s) => s.id == this.user.country_id
        ) || {};
      this.user.default_currency =
        this.user.organization && this.user.organization.default_currency_id
          ? this.currencies.find(
              (s) => s.id == this.user.organization.default_currency_id
            )
          : {};
      this.user.industry = this.user.organization
        ? this.$store.getters["global/industries"].find(
            (s) => s.id == this.user.organization.industry_id
          )
        : {};
      this.user.pay_period = this.user.organization
        ? this.$store.getters["global/pay_periods"].find(
            (s) => s.id == this.user.organization.pay_period_id
          )
        : "N/A";

      if (this.addresses && this.addresses[0]) {
        let orgAddress = this.addresses[0];
        this.user.address =
          orgAddress.address && orgAddress.address.data
            ? orgAddress.address.data
            : {};
      }
    },
    setDeleteState(name, id) {
      this.showDelete = true;
      this.showDeleteName = name;
      this.selectedDeleteId = id;
    },
    cancelDelete() {
      this.showDelete = false;
    },
    deletePaymentMethod() {
        this.$store
          .dispatch("payments/deletePaymentMethod", this.selectedDeleteId )
          .then((s) => {
              this.$toast.success("🚮 Payment method Successfully Deleted", {
                position: "top-right",
                duration: 3000,
              });
              this.showDelete = false;
              this.$store.commit(
                "payments/SET_USER_PAYMENT_METHODS",
                this.payment_methods.filter(s => s.id !== this.selectedDeleteId)
              );
            
              
          })
          .catch((error) => {
            console.log(error.data);

            this.showDelete = false;
          });
      
    },
  },
  computed: {
    payment_methods() {
      let payment_methods = this.$store.getters["payments/payment_methods"];
      let self = this;
      return payment_methods.map((s) => {
        //assign logo to them
        let logo = self.payment_processors.find((k) => k.name == s.name);
        s.logo = logo && logo.icon ? logo.icon : "";
        return s;
      });
    },
    currencies() {
      return this.$store.getters["global/currencies"];
    },
    addresses() {
      return this.$store.getters["global/organization_addresses"];
    },
    breadCrumbs() {
      return [
        {
          text: "Home",
          to: { name: "home" },
        },
        {
          text: "Organization",
          to: { name: "users-index" },
        },
        {
          text:
            this.user && this.user.organization && this.user.organization.name,
          to: "",
        },
      ];
    },
    payPeriods() {
      return this.$store.getters["global/pay_periods"];
    },
  },
  created() {
    Promise.all([
      this.payPeriods.length || this.$store.dispatch("global/getPayPeriods"),
      this.currencies.length || this.$store.dispatch("global/getCurrencies"),
      this.addresses.length || this.$store.dispatch("global/getOrganizationAddresses"),
      this.$store.getters["global/countries"].length || this.$store.dispatch("global/getCountries"),
      this.$store.getters["global/industries"].length || this.$store.dispatch("global/getIndustries"),
      this.$store.dispatch("payments/getPaymentMethods"),
      this.$auth.refresh(),
    ]).finally(() => {
      this.formatData();
      this.loaded = true;
    });
  },
};
</script>
